import { parseInteger } from "../../../util/utility";
import { CXoneEvent } from './cxone-event';

/**
 * Class to parse agent queues contact detail
 */
export class AgentQueuesDetail extends CXoneEvent {
  /**
   * @remarks - Unique identifier for agent
   */
  agentId!: number;

  /**
   * @remarks - Unique identifier for business unit(Tenant)
   */
  businessUnitId!: number;

  /**
   * @remarks - Name of the Campaign
   */
  campaignName!: string;

  /**
   * @remarks - Unique identifier for Campaign
   */
  campaignId!: number;

  /**
   * @remarks - Unique identifier for contact
   */
  contactId!: number;

  /**
   * @remarks -
   */
  contactStateCode!: number;

  /**
   * @remarks -
   */
  currentContactState!: string;

  /**
   * @remarks - first name of contact
   */
  firstName!: string;

  /**
   * @remarks - from address
   */
  fromAddr!: string;

  /**
   * @remarks - last name of contact
   */
  lastName!: string;

  /**
   * @remarks - last update time for the contact
   */
  lastUpdateTime!: Date;

  /**
   * @remarks - Unique identifier for master contact
   */
  masterContactId!: number;

  /**
   * @remarks - Name of media
   */
  mediaName!: string;

  /**
   * @remarks - Type of media
   */
  mediaType!: number;

  /**
   * @remarks - Name of Skill
   */
  skillName!: string;

  /**
   * @remarks - Unique identifier for Skill
   */
  skillId!: number;

  /**
   * @remarks - Start date of contact
   */
  startDate!: Date;

  /**
   * @remarks - Name of Team
   */
  teamName!: string;

  /**
   * @remarks - Unique identifier for agent
   */
  teamId!: number;

  /**
   * @remarks - to address
   */
  toAddr!: string;

  /**
   * This method to parse agent queues contact detail data
   * @param data - Agent queues contact detail
   * @example -
   * ```
   * parse(data);
   * ```
   */
  parse(data: { [key: string]: string }): void {
    this.agentId = parseInteger(data.agentId);
    this.businessUnitId = parseInteger(data.businessUnitId);
    this.campaignName = data.campaignName;
    this.campaignId = parseInteger(data.campaignId);
    this.contactId = parseInteger(data.contactId);
    this.contactStateCode = parseInteger(data.contactStateCode);
    this.currentContactState = data.currentContactState;
    this.firstName = data.firstName;
    this.fromAddr = data.fromAddr;
    this.lastName = data.lastName;
    this.lastUpdateTime = new Date(data.lastUpdateTime);
    this.masterContactId = parseInteger(data.masterContactId);
    this.mediaName = data.mediaName;
    this.mediaType = parseInteger(data.mediaType);
    this.skillName = data.skillName;
    this.skillId = parseInteger(data.skillId);
    this.startDate = new Date(data.startDate);
    this.teamName = data.teamName;
    this.teamId = parseInteger(data.teamId);
    this.toAddr = data.toAddr;
  }
}
